import {createSelector, createSlice} from '@reduxjs/toolkit'
import {apiCore, apiCoreV2} from "../apiSlice/apiCore";

const getCreditPlansApi = apiCoreV2
    .injectEndpoints({
        endpoints: (build) => ({
            getCreditPlans: build.query({
                providesTags: ['get-credit-plans'],
                query: () => '/get-credit-plans/',
                transformResponse: (response) => response ?? []
            }),
            getAvailablePlan: build.query({
                providesTags: ['get-available-plans'],
                query: () => "/get-available-plans"
            })
        })
    })

// const chooseCreditPlanApi = apiCoreV2
//     .injectEndpoints({
//         endpoints: (build) => ({
//             chooseCreditPlan: build.mutation({
//                 invalidatesTags: ['get-user-auth-status'],
//                 query: (arg) => ({
//                     url: '/choose-credit-plans/',
//                     method: "POST",
//                     body: {
//                         plan: arg?.planId,
//                     }
//                 })
//             })
//         })
//     })

export const {useGetCreditPlansQuery, useGetAvailablePlanQuery} = getCreditPlansApi;
// export const {useChooseCreditPlanMutation} = chooseCreditPlanApi;

const providerSlice = createSlice({
    name: 'providerSlice',
    initialState: {
        provider: {
            data: [],
            targetProvider: {},
            targetAmount: {},
            calculatedInstallments: {},
            selectedplan: {},
            status: "idle",
            errorMsg: ""
        }
    },
    reducers: {
        getTargetProvider: (state, action) => {
            state.provider.targetProvider = state.provider?.data?.find((p, i) => i === action.payload.activeIndex)
        },
        // getTargetAmount: (state, action) => {
        //     const newObj = {...state.provider?.targetProvider}
        //     state.provider.targetAmount = newObj?.plans?.find((p, i) => i === action.payload.activeIndex)
        // },
        // calculatorInstallments: (state, action) => {
        //     state.provider.calculatedInstallments = state.provider?.targetAmount?.items?.find((p, i) => i === action.payload.activeIndex)
        // }
    },
    extraReducers: (builder) => {
        builder.addMatcher(getCreditPlansApi.endpoints.getCreditPlans.matchPending, (state) => {
            state.provider.status = 'loading'
        })
        builder.addMatcher(getCreditPlansApi.endpoints.getCreditPlans.matchFulfilled, (state, {payload}) => {
            state.provider.data = payload;
            state.provider.status = 'fulfilled'
        })
        builder.addMatcher(getCreditPlansApi.endpoints.getCreditPlans.matchRejected, (state) => {
            state.provider.status = 'rejected'
            state.provider.errorMsg = 'data fetch failed!'
        })
    },
})

// export const useProviders = ({activeIndex}) => createSelector(
//     (state) => state.providerSlice?.provider?.data,
//     (data) => data.find((val, index) => index === activeIndex)
// )
export const useProviders = createSelector(
    (state) => state?.providerSlice?.provider?.targetProvider,
    (targetProvider) => targetProvider
)
export const useGetTargetAmount = ({activeIndex}) => createSelector(
    (state) => state?.providerSlice?.provider?.targetProvider,
    (targetProvider) => targetProvider?.plans?.find((p, i) => i === activeIndex)?.items
)

export const useCalculatorInstallments = ({planIndex, itemIndex}) => createSelector(
    (state) => state?.providerSlice?.provider?.targetProvider,
    (targetProvider) => {
        return targetProvider?.plans?.find((p, i) => i === planIndex)?.items?.find((p, i) => i === itemIndex)
    }
)

// export const useGetRepaymentOptions = ({activeIndex}) => createSelector(
//     (state) => state?.providerSlice?.provider?.targetAmount,
//     (targetAmount) => targetAmount?.items?.find((p, i) => i === activeIndex)
// )

export const useCalculatedInstallments = createSelector(
    (state) => state?.providerSlice?.provider?.calculatedInstallments,
    (calculatedInstallments) => calculatedInstallments
)

export const {getTargetProvider, getTargetAmount, calculatorInstallments} = providerSlice.actions
export default providerSlice.reducer